// extracted by mini-css-extract-plugin
export default {"sticky":"fSrCr22Rfp9FE9mzRURk","placeHolderShimmer":"yIb_uryCOW1pO6euVJaw"};